var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "videojs-box" }, [
    _c(
      "video",
      {
        ref: "video",
        staticClass: "video-js vjs-big-play-centered",
        attrs: {
          id: "my-player",
          preload: "auto",
          poster: "//image.micoworld.net/" + _vm.profile.cover,
          playsinline: "",
          "data-setup": "{}",
        },
      },
      [_vm._m(0)]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "vjs-no-js" }, [
      _vm._v(
        "\n      To view this video please enable JavaScript, and consider upgrading to a\n      web browser that\n      "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://videojs.com/html5-video-support/",
            target: "_blank",
          },
        },
        [_vm._v("\n        supports HTML5 video\n      ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }